import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheatSheets = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4998 3C20.2219 3 21 3.77778 21 6.5C21 9.22222 20.1919 10 17.4998 10L6.49982 10C3.80769 10 3 9.22222 3 6.5C3 3.77778 3.77778 3 6.49982 3L17.4998 3Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4998 14C20.2219 14 21 14.7778 21 17.5C21 20.2222 20.1919 21 17.4998 21L6.49982 21C3.80769 21 3 20.2222 3 17.5C3 14.7778 3.77778 14 6.49982 14L17.4998 14Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCheatSheets);
export { ForwardRef as ReactComponent };
